// @flow
import React, { PureComponent } from 'react';
import TagManager from 'react-gtm-module';

import BackgroundImage from 'components/fragments/BackgroundImage';
import SimpleCarousel from 'components/fragments/SimpleCarousel/SimpleCarousel';
import type { Bloc, BlocContent, Attributes } from 'types/NewsletterBloc';
import { dynamicClassName } from 'utils/dynamicClassName';

import './HTMLGallery.css';

export type Props = {
  childrens: Array<Bloc | BlocContent>,
  attributes: Array<Attributes>,
  tagName: string
};

export type ComponentState = {
  focusImg: number,
  caroussel: boolean
};

class HTMLGallery extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    focusImg: 0,
    caroussel: false
  };

  handleClick = (id: number) => {
    return () => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'eventGA',
          eventCategory: 'module gallerie',
          eventAction: 'clic photo',
          eventLabel: window.location.pathname
        },
        dataLayerName: 'dataLayer'
      });

      this.setState({
        focusImg: id
      });
    };
  };

  renderBigImg = (childrens: Array<Bloc | BlocContent>) => {
    const { focusImg } = this.state;

    if (childrens[focusImg]) {
      if (childrens[focusImg].featured_image) {
        return (
          <figure onClick={this.openCaroussel}>
            <img src={childrens[focusImg].featured_image.src} alt="" />
            <figcaption></figcaption>
          </figure>
        );
      } else if (!!childrens[focusImg].children && !!childrens[focusImg].children.length) {
        const imageChild = childrens[focusImg].children.find(child => child.tagName === 'img');

        if (
          typeof imageChild !== 'undefined' &&
          !!imageChild &&
          !!imageChild.attributes &&
          !!imageChild.attributes.length
        ) {
          const imageSrcAttr = imageChild.attributes.find(attr => attr.name === 'src');

          if (!!imageSrcAttr && !!imageSrcAttr.value) {
            return (
              <figure onClick={this.openCaroussel}>
                <img src={imageSrcAttr.value} alt="" />
                <figcaption></figcaption>
              </figure>
            );
          }
        }
      }
    }
    return null;
  };

  openCaroussel = () => {
    this.setState({
      caroussel: true
    });
  };

  closeCaroussel = () => {
    this.setState({
      caroussel: false
    });
  };

  renderListImg = (childrens: Array<Bloc | BlocContent>): Array<React$Node> => {
    const { focusImg } = this.state;

    return childrens.map((blocFigure: Bloc | BlocContent, index: number) => {
      if (blocFigure && blocFigure.featured_image) {
        const pictureClassName = dynamicClassName('picture');
        if (index === focusImg) {
          pictureClassName.add('picture--active');
        }
        return (
          <div
            role="button"
            tabIndex={0}
            className={pictureClassName.build()}
            key={index}
            onClick={this.handleClick(index)}
          >
            <BackgroundImage
              className="picture__thumbnail"
              illustration={blocFigure.featured_image?.src || ''}
              srcSet={blocFigure.featured_image?.sizes || undefined}
            />
          </div>
        );
      } else if (blocFigure && blocFigure.children && blocFigure.children.length) {
        const imageChild = blocFigure.children.find(child => child.tagName === 'img');

        if (imageChild && imageChild.attributes && imageChild.attributes.length) {
          const imageSrcAttr = imageChild.attributes.find(attr => attr.name === 'src');
          const imageSrcsetAttr = imageChild.attributes
            ? imageChild.attributes.find(attr => attr.name === 'srcset')
            : false;

          if (imageSrcAttr && imageSrcAttr.value && imageSrcsetAttr && imageSrcsetAttr.value) {
            const pictureClassName = dynamicClassName('picture');
            if (index === focusImg) {
              pictureClassName.add('picture--active');
            }

            return (
              <div
                role="button"
                tabIndex={0}
                className={pictureClassName.build()}
                key={index}
                onClick={this.handleClick(index)}
              >
                <BackgroundImage
                  className="picture__thumbnail"
                  illustration={imageSrcAttr.value}
                  srcset={{ srcSet: imageSrcsetAttr.value } || undefined}
                />
              </div>
            );
          }
        }
      }

      return null;
    });
  };

  render() {
    const { caroussel, focusImg } = this.state;
    const { childrens } = this.props;

    let childGallery = childrens;
    if (childrens.length > 0 && childrens[0].tagName === 'gallery' && childrens[0].children) {
      childGallery = childrens[0].children;
    }

    return (
      <section className="container--full carousel-photo">
        {caroussel && <SimpleCarousel onCloseRequest={this.closeCaroussel} data={childrens} initialIndex={focusImg} />}
        {this.renderBigImg(childGallery)}
        <div className="news-slider">
          <div className="news-slider__wrapper news-slider__wrapper--picture">{this.renderListImg(childGallery)}</div>
        </div>
      </section>
    );
  }
}

export default HTMLGallery;
